import { Path, QueryFilter } from '@softline/core';
import { FilterItemConfig } from '../../../types/filter-config';

export abstract class PageFilterDataService<T extends object> {
  abstract loadCount(items: FilterItemConfig<T>[], queryFilter: QueryFilter<T>): Promise<Record<Path<T>, number>>;
  abstract loadItems(item: FilterItemConfig<T>, filter: QueryFilter<T> | null, start: number, end: number, search: string): Promise<Partial<T>[]>
}
